import * as React from 'react'
import { PreviewCard as BasePreviewCard } from '@base-ui/react/preview-card'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

export interface PositionerProps extends PartProps<React.ComponentProps<typeof BasePreviewCard.Positioner>> {
  className?: string
}

export function Positioner({ className, ...props }: PositionerProps) {
  return <BasePreviewCard.Positioner className={twMerge('z-50 overflow-visible', className)} {...props} />
}
